import { config } from '@/config';

/**
 * Returns the full URL for an airline icon image.
 * Uses config.airlineIconsBaseUrl (default https://fly360.online/backend/airlines/) + airlineCode + '.png'
 */
export function getAirlineIconUrl(airlineCode?: string | null): string {
  const base = config.apiUrl + '/airlines/';
  const normalized = String(airlineCode ?? 'none').trim() || 'none';
  const url = base.endsWith('/') ? base : `${base}/`;
  return `${url}${normalized}.png`;
}
